import {
  DEFAULT_EMPLOYER_STATUSES, DEFAULT_STATUS_REQUIRE_REASON_CHANGE,
  DEFAULT_DASHBOARD_TABLE_FIELDS_EMPLOYER,
  DEFAULT_ANALYTICS_DASHBOARD_SELECTION,
  DEFAULT_RELATIONSHIP_STATUSES_HIDDEN_MY_CANDIDATES
} from "../../constants/default-values";
import { getPreviousDate } from "../../utils/datetime-handling";
import { getLatestList } from "../../utils/data-handling";
import axios from 'axios';
import tryGet from '../../utils/try-get'
import { getRequestUrlParams } from './../../utils/data-handling';
import { appendBackgroundParam } from "../../utils/query-handling";
import { mergeArrayOfObject } from "../../utils/array-handling";


const state = {
  employerStatuses: DEFAULT_EMPLOYER_STATUSES,
  employerAdminChecklist: [],
  employerList: [],
  employerListMainInfo: [], //id, names, email
  employerListIdNames: null,
  employerLastLoginFilter: null,
  listNumberChildren: null
};

const mutations = {
  setEmployerStatuses(state, employerStatuses) {
    state.employerStatuses = employerStatuses;
  },
  setEmployerAdminChecklist(state, employerAdminChecklist) {
    state.employerAdminChecklist = employerAdminChecklist;
  },
  setEmployerList(state, employerList) {
    state.employerList = employerList;
  },
  setEmployerListMainInfo(state, employerListMainInfo) {
    state.employerListMainInfo = employerListMainInfo;
  },
  setEmployerListIdNames(state, employerListIdNames) {
    state.employerListIdNames = employerListIdNames;
  },
  setEmployerLastLoginFilter(state, payload) {
    state.employerLastLoginFilter = payload;
  },
  setListNumberChildren(state, payload) {
    state.listNumberChildren = payload;
  },
};

const actions = {
  setEmployerStatuses({ commit }, payload) {
    if (payload && Array.isArray(payload) && payload.length > 0) {
      commit("setEmployerStatuses", payload);
    } else {
      // If payload is invalid (not an array or empty array), default employer statuses are used
      commit("setEmployerStatuses", DEFAULT_EMPLOYER_STATUSES);
    }
  },
  setEmployerAdminChecklist({ commit }, payload) {
    if (payload && Array.isArray(payload)) {
      commit("setEmployerAdminChecklist", payload);
    } else {
      // If payload is invalid (not an array), checklist is empty array
      commit("setEmployerAdminChecklist", []);
    }
  },
  setEmployerList({ commit }, payload) {
    commit("setEmployerList", payload);
  },
  setEmployerListMainInfo({ commit }, payload) {
    commit("setEmployerListMainInfo", payload);
  },
  setEmployerListIdNames({ commit }, payload) {
    commit("setEmployerListIdNames", payload);
  },
  setEmployerLastLoginFilter({ commit }, payload) {
    commit("setEmployerLastLoginFilter", payload);
  },
  setEmployerLastLoginRetrievalDays({ commit }, numberOfDay) {
    if (!numberOfDay || isNaN(numberOfDay)) {
      commit("setEmployerLastLoginFilter", null);
      return;
    }
    const date = new Date();
    date.setDate(date.getDate() - numberOfDay);
    const dateString = date.getFullYear().toString() +
      "-" +
      ("0" + (date.getMonth() + 1).toString()).slice(-2) +
      "-" +
      ("0" + date.getDate().toString()).slice(-2);
    commit("setEmployerLastLoginFilter", dateString);
  },
  reloadEmployerList({ commit, state, rootState, getters }, params) {
    return new Promise(async (resolve) => {
      const loadAllFields = params && params.loadAllFields;
      const loadExportFields = params && params.loadExportFields;
      let url = `/get-users/?user_type=clients&agency=${rootState.authentication.agencyID}`;
      const inBackground = params && params.inBackground;
      if (inBackground) {
        url = appendBackgroundParam(url);
        let lastId = null;
        if (getters.employerList.length) {
          const lastItem = getters.employerList.reduce((max, user) => max.last_updated_date > user.last_updated_date ? max : user);
          if (lastItem) {
            lastId = lastItem.id;
          }
        }
        if (lastId) {
          url = `${url}&last_id=${lastId}`;
        }
      }
      if (!loadAllFields) {
        let listModels = [...getters.employerTableFields, ...getters.employerSearchFields].map(field => field.model);
        listModels = listModels.filter(model => model !== 'first_name_last_name' && model !== 'secondary_first_name_secondary_last_name'
          && model !== 'adminNotes');
        listModels = [...listModels, 'created_date', 'id', 'status', 'types', 'first_name', 'last_name',
          'locations', 'last_login', 'last_updated_date', 'last_activity', 'email', 'phone', 'address1', 'is_employer', 'marketing_source',
          'secondary_first_name', 'secondary_last_name'];
        if (loadExportFields) {
          if (
            rootState.agency.advance_setting &&
            rootState.agency.advance_setting.client_mailing_fields
          ) {
            let setFields =
              rootState.agency.advance_setting.client_mailing_fields;
            let exportFields = [...setFields].map(field => field.model)
            console.log(exportFields)
            listModels = [...listModels, ...exportFields]
          }
        }
        listModels = [...new Set(listModels)]
        url += `&fields=${listModels.join(',')}`;
      }
      // Add filter param (last login date)
      if (state.employerLastLoginFilter) {
        url += `&recent_activity_filter=${state.employerLastLoginFilter}`;
      }
      const res = await axios.get(url);
      let listUsers = res.data.users;
      if (inBackground) {
        listUsers = mergeArrayOfObject(getters.employerList, listUsers);
      }
      commit("setEmployerList", listUsers);
      resolve();
      return;
    })
  },
  async loadClientListByModels({ rootState }, listModels) {
    return new Promise(async (resolve) => {
      const url = `/get-users/?user_type=clients&agency=${rootState.authentication.agencyID}&fields=${listModels.join(',')}`;
      const res = await axios.get(url);
      resolve(res.data.users);
    });
  },
  async reloadEmployerListMainInfo({ commit }) {
    const res = await axios.get(
      `/get-users/?user_type=clients&names_and_emails_only=true`
    );
    if (res) {
      commit('setEmployerListMainInfo', res.data.users);
    }
  },
  async loadListNumberChildren({ commit, rootState }) {
    return new Promise(async (resolve) => {
      const res = await axios.get(
        `/get-all-number-children/?agency=${rootState.authentication.agencyID}`
      );
      if (res) {
        commit('setListNumberChildren', res.data);
      }
      resolve();
    });
  },
  loadEmployerListIdNames({ commit, state, rootState }, params) {
    return new Promise(async (resolve) => {
      let isReload = false;
      let isBackground = false;
      if (params) {
        isReload = params.isReload;
        isBackground = params.isBackground;
      }
      if (!isReload && state.employerListIdNames) {
        resolve();
        return;
      }
      let url = `/get-users/?agency=${rootState.authentication.agencyID.toString()}&user_type=clients&fields=id,first_name,last_name`;
      if (isBackground) {
        url = `${url}&in_background=true`
      }
      const res = await axios.get(
        url
      );
      if (res && res.data) {
        commit("setEmployerListIdNames", res.data.users);
      }
      resolve();
    });
  },
  async getClientList(_, payload) {
    return await new Promise((resolve, reject) => {
      let url = 'optimize/get-clients/?'
      if (payload) {
        url = `${url}&${getRequestUrlParams(payload)}`
      }
      axios.get(url)
        .then((response) => {
          if (response.status === 200) {
            resolve(response);
          }
        }).catch((err) => {
          reject(err)
        });
    })
  },
};

const getters = {
  employerStatuses(state, getters, rootState) {
    let result = tryGet(() => rootState.agency.agencyPublic.employer_statuses);
    if (result && result.length) {
      return result;
    }
    return DEFAULT_EMPLOYER_STATUSES;
  },
  employerAdminChecklist(state) {
    return state.employerAdminChecklist;
  },
  employerList(state) {
    return state.employerList;
  },
  employerListMainInfo(state) {
    return state.employerListMainInfo || [];
  },
  employerListIdNames(state) {
    return state.employerListIdNames;
  },
  employerLastLoginFilter(state) {
    return state.employerLastLoginFilter;
  },
  listNumberChildren(state) {
    return state.listNumberChildren;
  },
  employerTypes(state, getters, rootState) {
    return tryGet(() => rootState.agency.agencyPublic.employer_types) || [];
  },
  employerTags(state, getters, rootState) {
    return tryGet(() => rootState.agency.agencyPublic.employer_tags) || [];
  },
  employerTableFields(state, getters, rootState) {
    // Check admin level setting
    const adminSetting = rootState.general.adminSetting;
    if (adminSetting && adminSetting.setting && adminSetting.setting.use_admin_level__employer_table_fields) {
      const adminLevelSetting = adminSetting.setting.admin_level__employer_table_fields;
      if (adminLevelSetting && adminLevelSetting.length) {
        return adminLevelSetting;
      }
    }
    // Check agency level setting
    const agency = rootState.authentication.agency;
    const listFields = agency.employer_table_fields;
    if (listFields && listFields.length) {
      return listFields;
    }
    return DEFAULT_DASHBOARD_TABLE_FIELDS_EMPLOYER;
  },
  employerSearchFields(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const listFields = agency.advance_setting.employer_search_fields;
      if (listFields && listFields.length) {
        return listFields;
      }
    }
    return [];
  },
  employerStatusRequireReason(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (
      agency &&
      agency.public_advance_setting &&
      agency.public_advance_setting.employer_status_require_reason != null) {
      return agency.public_advance_setting.employer_status_require_reason;
    }
    return DEFAULT_STATUS_REQUIRE_REASON_CHANGE;
  },
  employerStatusReasonOptions(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (
      agency &&
      agency.public_advance_setting &&
      agency.public_advance_setting.employer_status_reason_options) {
      return agency.public_advance_setting.employer_status_reason_options;
    }
    return {};
  },
  employerSecondStatuses(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (
      agency &&
      agency.public_advance_setting &&
      agency.public_advance_setting.employer_second_statuses) {
      return agency.public_advance_setting.employer_second_statuses;
    }
    return [];
  },
  showCandidateRateToClient(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.show_candidate_rate_to_client;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is false
  },
  showClientRateToClient(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.show_client_rate_to_client;
      if (result != null) {
        return result;
      }
    }
    return true;
  },
  clientTypeNotPutPaymentInfo(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.client_types_not_put_payment_info) {
      return agency.advance_setting.client_types_not_put_payment_info
    }
    return [];
  },
  clientTypeNotChargeRegistrationFee(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.client_types_not_charge_registration_fee) {
      return agency.advance_setting.client_types_not_charge_registration_fee
    }
    return [];
  },
  clientAnalyticsDashboardFields(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const listFields = agency.advance_setting.client_analytics_dashboard_fields;
      if (listFields && listFields.length) {
        return listFields;
      }
    }
    return DEFAULT_ANALYTICS_DASHBOARD_SELECTION;
  },
  clientTypesUseBookingCredits(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting && agency.advance_setting.client_types_use_booking_credits) {
      return agency.advance_setting.client_types_use_booking_credits
    }
    return [];
  },
  agencyUseBookingCredits(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.use_booking_credits) {
      return agency.use_booking_credits
    }
    return false;
  },
  employerStatisticsStatuses(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.public_advance_setting.employer_statistic_status) {
      return agency.public_advance_setting.employer_statistic_status
    }
    return DEFAULT_EMPLOYER_STATUSES
  },
  clientTableStatusColors: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.client_table_status_color) || [],
  clientShiftJobProfile: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.client_shift_job_profile) || [],
  clientShiftJobProfileAssigneeView: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.client_shift_job_profile_assignee) || [],
  useEmployerNameInHeaderTemplate: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.use_employer_name_in_header_template) || false,
  hideClientShareableLink: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.hide_client_shareable_link) || false,
  showClientPdfButtonOfCandidateProfile: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.show_client_pdf_button_of_candidate_profile) || false,
  showClientGeneratePdfButton: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.show_client_generate_pdf_button) || false,
  labelEmployerStatuses: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.label_employer_statuses),
  labelEmployerSecondStatuses: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.label_employer_second_statuses),
  clientTypesViewOnlyBooking: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.client_types_view_only_booking) || [],
  hideExtendOfferButton: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.hide_extend_offer_button) || false,
  employerDocumentDefaultScope: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.client_default_document_scope) || 'private',
  disableClientAssignManagerEmail: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.disable_client_assign_manager_email) || false,
  hideNotInterestedButton: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.hide_not_interested_button) || false,
  clientTagsRelevantMatching: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.client_tags_relevant_matching) || [],
  hideGuideTextMyCandidateSection: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.hide_guide_text_my_candidate_section) || false,
  clientPostPlacementJobDefaultStatus: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.client_post_placement_job_default_status) || 'Posted',
  clientsCanMakePlacementJobRequests: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.clients_can_make_placement_job_requests) || false,
  notifyEmailsClientPostPlacementJob: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.notify_emails_client_post_placement_job) || [],
  clientProfileTopWelcomeText: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.client_profile_top_welcome_text) || '',
  notifyEmailsClientUpdatesCreditCard: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.notify_emails_client_updates_credit_card) || [],
  relationshipStatusAccessibleClientProfilePic: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.relationship_status_accessible_client_profile_pic) || [],
  clientProfilePicVisibleToFiller: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.client_profile_pic_visible_to_filler) || false,
  updateClientStatusWhenAllDocumentSigned: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.update_client_status_when_all_document_signed) || false,
  clientStatusToUpdateWhenAllDocumentSigned: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.client_status_to_update_when_all_documents_signed) || '',
  clientProfileCompleteButtonText: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.client_profile_complete_button_text) || 'My Profile is Complete, Notify Agency',
  showAssignedCandidateShareableLinkClient: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.show_assigned_candidate_shareable_link_client) || false,
  clientAddNoteAssignedCandidateNotificationEmails: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.client_add_note_assigned_candidate_notification_emails) || [],
  removeClientUploadAdditionalDocumentButton: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.remove_client_upload_additional_document_button) || false,
  wordUsedForScheduleInterview: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.word_used_for_schedule_interview_relationship) || 'Schedule Interview',
  showEmployerDialogInRight: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.show_employer_dialog_in_right) || false,
  notifyEmailsPackageSelectOrChange: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.notify_emails_package_select_or_change) || [],
  showShareableLinkForMyCandidatesSection: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.show_shareable_link_for_my_candidates_section) || false,
  relationshipStatusesWhereExtendedOfferButtonAppears: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.relationship_statuses_where_extended_offer_button_appears) || ['Interested'],
  relationshipStatusesHiddenMyCandidates: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.relationship_statuses_hidden_my_candidates) || DEFAULT_RELATIONSHIP_STATUSES_HIDDEN_MY_CANDIDATES,
  clientReapplicationStatuses: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.client_reapplication_statuses) || [],
  employerSearchBarOpenByDefault: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.employer_search_bar_open_by_default) || false,
  registrationFeeStripeDescription: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.registration_fee_stripe_description) || 'Application form fee',
  isEmployerEditableViewDefault: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.set_editable_view_default_client) || false,

};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/employers.js